import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabrentalwithdriver() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Rentals with Drivers in Kolkata',
    heading: 'Aaryan Travels: Monthly Corporate Cab Rentals with Drivers in Kolkata',
    headingDescription: 'Aaryan Travels provides dependable Monthly Corporate Cab Rentals with Drivers in Kolkata for companies, industrial units, and professionals who require regular transportation support. Whether it’s daily employee commuting, executive travel, airport transfers from Netaji Subhas Chandra Bose International Airport, or long-distance corporate visits to Ranchi, Durgapur, or Siliguri, our chauffeur-driven sedans, SUVs, and tempo travellers are available on fixed monthly rental plans. With disciplined drivers, GPS-enabled vehicles, timely reporting, and centralized billing, we ensure consistent and professional mobility across Salt Lake, New Town, Park Street, and Howrah. Aaryan Travels simplifies business travel with structured monthly corporate cab rental solutions in Kolkata.',

    top: 'Top Places to Visit in Kolkata with Aaryan Travels',

"topPlaces": [
  {
    "title": "Victoria Memorial",
    "description": "Victoria Memorial is a grand white marble monument built in honor of Queen Victoria. Surrounded by lush gardens and water bodies, it is now a museum showcasing colonial-era paintings, artifacts, and royal memorabilia. During the evening, the monument is beautifully illuminated. The sprawling lawns are perfect for leisure walks. Victoria Memorial is Kolkata’s iconic symbol of history and elegance."
  },
  {
    "title": "Howrah Bridge (Rabindra Setu)",
    "description": "Howrah Bridge is one of the world’s busiest cantilever bridges, connecting Kolkata and Howrah over the Hooghly River. Built without nuts or bolts, it stands as an engineering marvel. The bridge glows stunningly at night. Watching ferries and daily life around the riverbank is a mesmerizing experience. Howrah Bridge is Kolkata’s timeless gateway of connectivity and pride."
  },
  {
    "title": "Dakshineswar Kali Temple",
    "description": "Dakshineswar Kali Temple, located on the banks of the Hooghly River, is dedicated to Goddess Bhavatarini, a form of Kali. Associated with the saint Sri Ramakrishna Paramahamsa, it attracts thousands of devotees daily. The temple complex includes bathing ghats and peaceful surroundings. Dakshineswar Temple is Kolkata’s sacred haven of divine energy."
  },
  {
    "title": "Belur Math",
    "description": "Belur Math is the headquarters of the Ramakrishna Mission founded by Swami Vivekananda. Its architecture blends Hindu, Christian, and Islamic styles, symbolizing unity among religions. The tranquil riverfront setting makes it ideal for meditation and reflection. Evening prayers here are deeply soothing. Belur Math is Kolkata’s beacon of peace and spiritual harmony."
  },
  {
    "title": "Park Street",
    "description": "Park Street is Kolkata’s entertainment hub known for iconic restaurants, bakeries, and nightlife. Legendary eateries like Flurys and Peter Cat draw food lovers from across the globe. The street comes alive with music, lights, and festive decor during Christmas and New Year. Park Street is Kolkata’s vibrant boulevard of joy and celebration."
  },
  {
    "title": "Indian Museum",
    "description": "Founded in 1814, the Indian Museum is India’s oldest and largest museum. It houses Egyptian mummies, dinosaur fossils, ancient sculptures, and Mughal paintings. Each gallery offers a fascinating journey through history, art, and science. The massive building itself is a colonial architectural gem. Indian Museum is Kolkata’s treasure trove of knowledge."
  },
  {
    "title": "St. Paul’s Cathedral",
    "description": "St. Paul’s Cathedral is a beautiful Gothic-style church known for its towering spires and stained-glass windows. Built in 1847, it offers a peaceful retreat amidst the city’s buzz. The church looks especially enchanting during Christmas. Its lush lawns add to the serenity. St. Paul’s Cathedral is Kolkata’s elegant landmark of faith."
  },
  {
    "title": "Science City",
    "description": "Science City is India’s largest science center featuring interactive exhibits, a space theater, ropeway rides, and illusion tunnels. It offers fun learning experiences for both kids and adults. The Earth Exploration Hall and time travel simulators are crowd favorites. Science City is Kolkata’s futuristic world of education and entertainment."
  },
  {
    "title": "Kalighat Temple",
    "description": "Kalighat Temple is one of the 51 Shakti Peethas dedicated to Goddess Kali. Despite the crowds, it radiates strong spiritual energy. Devotees come to offer prayers and witness rituals. The surrounding market sells flowers, prasad, and religious items. Kalighat Temple is Kolkata’s ancient seat of devotion."
  },
  {
    "title": "Eco Park (Prakriti Tirtha)",
    "description": "Eco Park is a vast urban recreation space with themed gardens, water bodies, cycling tracks, and adventure sports. Replica monuments like the Eiffel Tower and Seven Wonders attract photo enthusiasts. Families flock here for picnics, boating, and evening leisure. Eco Park is Kolkata’s refreshing escape into greenery and fun."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Rentals with Drivers in Kolkata",
    "description": "Monthly Corporate Cab Rentals with Drivers in Kolkata offer businesses a comprehensive transportation solution that combines reliability, professionalism, and convenience. Designed for long-term corporate needs, this service provides a dedicated fleet of well-maintained vehicles driven by experienced chauffeurs who prioritize punctuality, safety, and comfort. Whether for daily office commutes, client meetings, or corporate events, companies can benefit from flexible plans, transparent pricing, and seamless management to ensure efficient employee transport over extended periods."
  },
  {
    "name": "Kolkata Monthly Corporate Cab with Driver",
    "description": "Kolkata Monthly Corporate Cab with Driver provides reliable chauffeur-driven cabs tailored for corporate clients. With dedicated drivers and premium vehicles, this service guarantees consistent, comfortable, and safe travel throughout the month, making it ideal for businesses looking to streamline their transportation needs."
  },
  {
    "name": "Chauffeur Corporate Cab Kolkata Monthly",
    "description": "Chauffeur Corporate Cab Kolkata Monthly focuses on delivering professional chauffeur services to corporate clients on a monthly basis. Drivers are trained in corporate etiquette, ensuring discreet and courteous service for executives and staff alike."
  },
  {
    "name": "Long Term Corporate Cab Kolkata",
    "description": "Long Term Corporate Cab Kolkata offers extended rental options with flexible terms, perfect for companies needing dependable transportation solutions for their workforce or clients. This service emphasizes vehicle quality, driver professionalism, and timely service."
  },
  {
    "name": "Business Cab Subscription Kolkata",
    "description": "Business Cab Subscription Kolkata allows companies to subscribe to regular cab services with predictable billing and priority availability. This subscription model enhances convenience and budget management for ongoing business travel requirements."
  },
  {
    "name": "Office Transport Kolkata Monthly",
    "description": "Office Transport Kolkata Monthly provides scheduled and reliable transportation for employees commuting to the office. This service focuses on punctuality and safety, helping businesses maintain smooth daily operations."
  },
  {
    "name": "Staff Cab Kolkata Monthly",
    "description": "Staff Cab Kolkata Monthly delivers affordable and consistent cab services for company staff on a monthly rental basis. With well-maintained vehicles and professional drivers, this service ensures employees travel comfortably and safely."
  },
  {
    "name": "Executive Corporate Cab Kolkata",
    "description": "Executive Corporate Cab Kolkata offers premium transportation solutions featuring luxury vehicles and skilled chauffeurs, tailored for senior executives and VIP clients requiring comfort, discretion, and professionalism."
  },
  {
    "name": "Affordable Corporate Cab Kolkata",
    "description": "Affordable Corporate Cab Kolkata balances cost-efficiency with quality, providing corporate clients with dependable transportation options that fit within budget constraints without compromising service standards."
  },
  {
    "name": "Corporate Vehicle Rental Kolkata",
    "description": "Corporate Vehicle Rental Kolkata presents a diverse fleet of vehicles available for corporate hire, suited to various business needs, with options for short or long-term rentals supported by experienced drivers."
  },
  {
    "name": "Corporate Car Leasing Kolkata",
    "description": "Corporate Car Leasing Kolkata offers flexible leasing solutions for businesses seeking dedicated vehicles over extended periods, inclusive of maintenance and driver services to ensure hassle-free corporate mobility."
  },
  {
    "name": "Online Corporate Cab Kolkata",
    "description": "Online Corporate Cab Kolkata streamlines the booking and management of corporate cabs with drivers through an intuitive digital platform, providing instant confirmations, real-time tracking, and efficient scheduling."
  },
  {
    "name": "Monthly Business Cab Kolkata",
    "description": "Monthly Business Cab Kolkata provides businesses with reliable and professional cab services tailored for ongoing monthly use, supporting daily commutes, meetings, and corporate travel requirements."
  },
  {
    "name": "Reliable Corporate Cab Kolkata",
    "description": "Reliable Corporate Cab Kolkata has built a reputation for consistent, timely, and professional corporate transportation services, ensuring businesses can trust their travel needs are met with excellence."
  },
  {
    "name": "Premium Corporate Cab Kolkata",
    "description": "Premium Corporate Cab Kolkata offers luxury corporate transportation services with a focus on elegance, comfort, and superior service. Ideal for VIP clients and important business occasions, this service ensures a premium travel experience."
  }
],
"tableData": [
  ["Monthly Corporate Cab Rentals with Drivers in Kolkata", "Kolkata Monthly Corporate Cab with Driver"],
  ["Chauffeur Corporate Cab Kolkata Monthly", "Long Term Corporate Cab Kolkata"],
  ["Business Cab Subscription Kolkata", "Office Transport Kolkata Monthly"],
  ["Staff Cab Kolkata Monthly", "Executive Corporate Cab Kolkata"],
  ["Affordable Corporate Cab Kolkata", "Corporate Vehicle Rental Kolkata"],
  ["Corporate Car Leasing Kolkata", "Online Corporate Cab Kolkata"],
  ["Monthly Business Cab Kolkata", "Reliable Corporate Cab Kolkata"],
  ["Premium Corporate Cab Kolkata", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Monthly Corporate Cab Rentals with Drivers in Kolkata",
    "WhyChoosedescription": "Aaryan Travels provides dependable monthly corporate cab rentals with professional drivers in Kolkata for seamless business commuting."
  },
  {
    "WhyChooseheading": "Punctual and Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure timely pickups and drop-offs to keep your corporate schedule on track."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for comfort and safety throughout the rental period."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Kolkata Routes",
    "WhyChoosedescription": "Our chauffeurs have expert knowledge of Kolkata’s roads to provide efficient and hassle-free rides."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed monthly rates that include fuel, tolls, and driver allowances for stress-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, schedule changes, and urgent requests."
  },
  {
    "WhyChooseheading": "Customizable Plans to Fit Your Business Needs",
    "WhyChoosedescription": "Choose from various plans and vehicle types tailored to your company’s corporate travel requirements."
  },
  {
    "WhyChooseheading": "Priority Service and Dedicated Fleet",
    "WhyChoosedescription": "Benefit from priority bookings and a dedicated fleet for uninterrupted corporate travel."
  }
]
















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab rentals with drivers in Kolkata?',
    answer: 'Yes, Aaryan Travels provides flexible and reliable monthly corporate cab rental plans with professional drivers in Kolkata.',
  },
  {
    question: 'How can I book monthly corporate cab rentals with drivers in Kolkata?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate rentals with drivers in Kolkata?',
    answer: 'Aaryan Travels offers a range of well-maintained sedans, SUVs, and premium cars suited for corporate travel.',
  },
  {
    question: 'Are the drivers experienced and trained for corporate cab services in Kolkata?',
    answer: 'Absolutely. Our drivers are licensed, punctual, and professionally trained to provide safe and efficient service.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for monthly rentals in Kolkata?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Kolkata and surrounding business areas.',
  },
  {
    question: 'Is the monthly corporate cab rental service available 24x7 in Kolkata?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed during monthly corporate cab rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for monthly corporate cab rentals in Kolkata?',
    answer: 'We accept payments via corporate accounts, UPI, digital wallets, credit/debit cards, and bank transfers.',
  },
  {
    question: 'Is customer support available throughout the monthly rental period?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout the rental duration.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Banerjee',
    feedback: 'Aaryan Travels’ monthly corporate cab rentals with drivers in Kolkata have been reliable and convenient for our business.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Das',
    feedback: 'Professional drivers and excellent service made our monthly corporate cab rentals hassle-free. Highly recommend Aaryan Travels.',
    rating: 5,
  },
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];






const monthlyCorporateCabRentalsKolkataSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Rentals with Drivers in Kolkata",
  "description": "Aaryan Travels offers reliable monthly corporate cab rentals with drivers in Kolkata, providing chauffeur-driven executive and staff transport for businesses on long-term plans.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Kolkata"
  },
  "serviceType": "Monthly Corporate Cab Rental with Driver",
  "keywords": "Monthly Corporate Cab Rentals with Drivers in Kolkata, Kolkata Monthly Corporate Cab with Driver, Chauffeur Corporate Cab Kolkata Monthly, Long Term Corporate Cab Kolkata, Business Cab Subscription Kolkata, Office Transport Kolkata Monthly, Staff Cab Kolkata Monthly, Executive Corporate Cab Kolkata, Affordable Corporate Cab Kolkata, Corporate Vehicle Rental Kolkata, Corporate Car Leasing Kolkata, Online Corporate Cab Kolkata, Monthly Business Cab Kolkata, Reliable Corporate Cab Kolkata, Premium Corporate Cab Kolkata"
};








  return (
    <div>

<Helmet>
  <title>Monthly Corporate Cab Rentals with Drivers in Kolkata | Reliable Chauffeur Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Book monthly corporate cab rentals with drivers in Kolkata from Aaryan Travels. Affordable and reliable chauffeur-driven corporate transportation solutions for your business."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Rentals with Drivers in Kolkata, Kolkata Monthly Corporate Cab with Driver, Chauffeur Corporate Cab Kolkata Monthly, Long Term Corporate Cab Kolkata, Business Cab Subscription Kolkata, Office Transport Kolkata Monthly, Staff Cab Kolkata Monthly, Executive Corporate Cab Kolkata, Affordable Corporate Cab Kolkata, Corporate Vehicle Rental Kolkata, Corporate Car Leasing Kolkata, Online Corporate Cab Kolkata, Monthly Business Cab Kolkata, Reliable Corporate Cab Kolkata, Premium Corporate Cab Kolkata"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateCabRentalsKolkataSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabrentalwithdriver;